import './ChecklistPanel.scss'

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import TaskDetailLoadingIndicator from '../TaskDetails/TaskDetailsLoadingIndicator'
import { isChecklistItemIdNew } from '../../util/checklistHelper'
import LocalizedString from '../LocalizedString'
import Checklist from './Checklist'

const isChecklistItemNew = (checklistItem) => {
  if (!checklistItem) return false
  return isChecklistItemIdNew(checklistItem.id)
}

/**
 * @augments{ Component<any, any> }
 */
export class ChecklistPanel extends Component {
  getChecklistItem = (index) => {
    return (index >= 0 && index < this.props.items.length)
      ? this.props.items[index]
      : null
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) {
      return
    }

    const checklistItem = this.props.items[oldIndex]
    const nextChecklistItemIndex = newIndex < oldIndex ? newIndex : newIndex + 1
    const nextChecklistItem = this.getChecklistItem(nextChecklistItemIndex)
    const prevChecklistItem = this.getChecklistItem(nextChecklistItemIndex - 1)

    // We can't guarantee consistency with server state if it doesn't know about the prev/next item
    if (!isChecklistItemNew(prevChecklistItem) && !isChecklistItemNew(nextChecklistItem)) {
      this.props.moveTaskChecklistItem(checklistItem.id, nextChecklistItem ? nextChecklistItem.id : null)
    }
  }

  render() {
    const { items } = this.props

    if (items && items.length === 0) {
      return null
    }

    return (
      <div className={`${this.props.className} task-modal__checklist`}>
        <div className='task-modal__field'>
          <LocalizedString resourceKey='taskBoards.Label_Checklist' />
        </div>
        <div className='task-modal__checklist-items'>
          { !items || !this.props.scrollContainer
            ? <TaskDetailLoadingIndicator />
            : <Checklist
              {...this.props}
              useDragHandle
              helperClass={'task-modal__checklist-helper'}
              getContainer={wrappedInstance => ReactDOM.findDOMNode(this.props.scrollContainer)}
              onSortEnd={this.onSortEnd}
              items={items} />
          }
        </div>
      </div>
    )
  }
}

ChecklistPanel.defaultProps = {
  className: ''
}

ChecklistPanel.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  moveTaskChecklistItem: PropTypes.func.isRequired,
  scrollContainer: PropTypes.object
}

export default ChecklistPanel



// WEBPACK FOOTER //
// ./src/components/ChecklistPanel/ChecklistPanel.js